import * as React from 'react';

import { translate } from '~l10n/client';

import { PaywallScreens } from '~analytics/types';
import { UIButton } from '~shared/components/buttons';
import { DialogProps } from '~shared/components/Dialog';
import {
  PaywallDialog,
  PaywallUpgradeButton,
} from '~teacher/components/PaywallDialog';

export type Props = Pick<DialogProps, 'open' | 'onClose'>;

export function ShareResultsPaywall(props: Props) {
  return (
    <PaywallDialog.Long
      id="share-results-paywall"
      title={translate('Upgrade to Share Results')}
      actions={[
        <UIButton key="cancel" onClick={props.onClose}>
          {translate('Cancel')}
        </UIButton>,
        <PaywallUpgradeButton
          key="upgrade"
          appearance="primary"
          paywallScreen={PaywallScreens.ReportEmailStudents}
        />,
      ]}
      paywallTouch={[PaywallScreens.ReportEmailStudents]}
      {...props}
    >
      <p className="m-0 pb-4 text-blue-900">
        {translate(
          'Share personalized results to each student who took part in the activity.'
        )}
      </p>
    </PaywallDialog.Long>
  );
}
